/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { UINotification } from '@poweralpha/common';
import { type Id, type ToastOptions, toast } from 'react-toastify';
import NotificationToast from './components/NotificationToast';
import { toastAutoClose } from './const';

export const notificationContainerId = 'notification-container';

const notificationToastOptions: ToastOptions = {
  autoClose: toastAutoClose,
  className: 'notification-toast',
  containerId: notificationContainerId,
  closeButton: false,
  closeOnClick: false,
  hideProgressBar: false,
  icon: false,
  pauseOnHover: true,
};

export function showNotificationToast(
  notification: UINotification,
  handleClick: (notif: UINotification, redirect?: boolean) => void,
): Id {
  return toast(
    (props) => (
      <NotificationToast
        {...props}
        notification={notification}
        content={notification.notif_content}
        handleClick={handleClick}
      />
    ),
    {
      ...notificationToastOptions,
      toastId: notification.id,
      type: notification.severity,
      onClose: (reason) => {
        if (reason === true) {
          handleClick(notification, false);
        }
      },
    },
  );
}
